<script setup>
const emits = defineEmits(["cargaGarantiaConfirmada"])

function irACargaGarantiaOnline() {
    window.location.href=`${process.env.VUE_APP_SISTEMA_SUBASTAS_ACTUAL_URL}/usuarios/credito`;
}
</script>
<template>

  <div class="modal fade" id="carga-garantia-modal-warning" tabindex="-1" aria-labelledby="carga-garantia-modal-warning-label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content p-4">
        <div class="d-flex flex-column justify-content-between align-items-center px-4 pt-4">
            <div class="modal-body p-4 w-100">
                <div>
                    
                </div>
                <div class="d-flex flex-row align-items-center">
                    <img src="@/assets/img/icons/warning.svg" class="p-2"/> 
                    <h5 class="p-2 text-soft-green">Atención: garantía solo para Subastas</h5>
                </div>
                <div>
                <p class="mb-0 pb-0">
                    Estás por ingresar una garantía que se aplicará únicamente a la modalidad <strong>Subasta,</strong> una modalidad diferente a la <strong>Subasta en Vivo.</strong>
                </p>
                <p>
                    Si necesitás cargar una garantía para <strong>Subasta en Vivo,</strong> hacé <strong @click="irACargaGarantiaOnline"  style=" cursor: pointer;text-decoration: underline;">click acá.</strong>
                </p>
                </div>
                <div>

                </div>
            </div>
            <div class="modal-footer sticky-footer w-100">
                <button class="btn btn-soft-green px-5" @click="emits('cargaGarantiaConfirmada')">
                    Ingresar Garantía
                </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>